















import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import { ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig } from "../../Models/Buttons";

@Component(
	{
		name: "ForgotPasswordForm",
		components: { ButtonList }
	})
export default class ForgotPasswordForm extends Vue {
	private email: string = "";
	@Prop() private buttons: ButtonConfig[];
	private validform: boolean = true;

	private get formvalid() {
		return this.validform;
	}

	private emailconfig =
		{
			props: { name: "email", placeholder: "Enter email", label: "Email", } as FormFieldProps,
			rules: { required: true, email: true } as FormFieldRules
		} as IFormField;

	// handle button clicks
	private async buttonClicked(clicked: ParticaEvent) {			{
			if (await this.validate()) {
				clicked.item = this.email;
				this.$emit("partica-event", clicked);
			}
		}
	}

	private async validate(): Promise<boolean> {
		{
			let result: boolean = true;
			await this.$validator.validateAll().then(valid => result = valid);
			return result;
		}
	}
}
